

// Disable band/cup chips if all corresponding combinations are unavailable
function updateBraSizeAvailability() {
  // Only run for bra products
  if (!$('#currproduct-type[value*="Bra"]').length) return;

  // Only run if we actually have band/cup chips (Complex Bra)
  if ($('.product__chip[data-type="band"]').length === 0) return;

  // Check if product has a color option
  var hasColor = $('.product__variants-wrapper').data('has-color');

  // Get the currently selected color if applicable
  var selectedColor = null;
  if (hasColor) {
    selectedColor = $('#option1').val();
    if (!selectedColor) {
      // On page load, the select might not be updated yet, try to get from swatch
      var $selectedSwatch = $('.product__color-swatch.selected, .product__chip.selected[data-type="color"]');
      if ($selectedSwatch.length) {
        selectedColor = $selectedSwatch.data('value');
      } else {
        return;
      }
    }
  }

  // Get all product variants from JSON
  var variantsJsonEl = $('[data-variant-json]');
  if (!variantsJsonEl.length) return;

  try {
    var variants = JSON.parse(variantsJsonEl.text());

  // Filter variants to only those matching the selected color (only if color option exists)
  var colorVariants = variants;
  if (hasColor) {
    colorVariants = variants.filter(function(variant) {
      return variant.option1 === selectedColor;
    });
  }

    // Get all band and cup chips
    var $bandChips = $('.product__chip[data-type="band"]');
    var $cupChips = $('.product__chip[data-type="cup"]');

    // Check if a specific band or cup is currently selected
    var $selectedBand = $('.product__chip[data-type="band"].selected');
    var $selectedCup = $('.product__chip[data-type="cup"].selected');
    var selectedBandValue = $selectedBand.length ? $selectedBand.data('value') : null;
    var selectedCupValue = $selectedCup.length ? $selectedCup.data('value') : null;

    // For each band, check availability
    $bandChips.each(function() {
      var bandValue = $(this).data('value');
      var hasAvailableCup = false;

      // If a cup is selected, only check that specific cup
      if (selectedCupValue) {
        var combinedSize = bandValue + selectedCupValue;
        var matchingVariant = colorVariants.find(function(variant) {
          var variantSize = hasColor ? variant.option2 : variant.option1;
          return variantSize === combinedSize;
        });
        if (matchingVariant && matchingVariant.available) {
          hasAvailableCup = true;
        }
      } else {
        // No cup selected, check if ANY cup combination is available
        $cupChips.each(function() {
          var cupValue = $(this).data('value');
          var combinedSize = bandValue + cupValue;

          var matchingVariant = colorVariants.find(function(variant) {
            var variantSize = hasColor ? variant.option2 : variant.option1;
            return variantSize === combinedSize;
          });

          if (matchingVariant && matchingVariant.available) {
            hasAvailableCup = true;
            return false; // break out of loop
          }
        });
      }

      // If no available cups for this band, disable the band chip
      if (!hasAvailableCup) {
        $(this).addClass('disabled');
      } else {
        $(this).removeClass('disabled');
      }
    });

    // For each cup, check availability
    $cupChips.each(function() {
      var cupValue = $(this).data('value');
      var hasAvailableBand = false;

      // If a band is selected, only check that specific band
      if (selectedBandValue) {
        var combinedSize = selectedBandValue + cupValue;
        var matchingVariant = colorVariants.find(function(variant) {
          var variantSize = hasColor ? variant.option2 : variant.option1;
          return variantSize === combinedSize;
        });
        if (matchingVariant && matchingVariant.available) {
          hasAvailableBand = true;
        }
      } else {
        // No band selected, check if ANY band combination is available
        $bandChips.each(function() {
          var bandValue = $(this).data('value');
          var combinedSize = bandValue + cupValue;

          var matchingVariant = colorVariants.find(function(variant) {
            var variantSize = hasColor ? variant.option2 : variant.option1;
            return variantSize === combinedSize;
          });

          if (matchingVariant && matchingVariant.available) {
            hasAvailableBand = true;
            return false; // break out of loop
          }
        });
      }

      // If no available bands for this cup, disable the cup chip
      if (!hasAvailableBand) {
        $(this).addClass('disabled');
      } else {
        $(this).removeClass('disabled');
      }
    });
  } catch(e) {
    console.error('Error in updateBraSizeAvailability:', e);
  }
}

// Add debounce flag to prevent infinite loops
var manageErrorTimeout = null;

function manageError() {
  // Debounce to prevent infinite loops
  if (manageErrorTimeout) {
    clearTimeout(manageErrorTimeout);
  }

  manageErrorTimeout = setTimeout(function() {
    executeManageError();
    manageErrorTimeout = null;
  }, 50);
}

function executeManageError() {
  var allSelected = true;
  var isComplexBra = $('#currproduct-type[value*="Bra"]').length && $('.product__chip[data-type="band"]').length > 0;

    if(isComplexBra){
      $('.product__color-chips:not(.chips2-wrap)').each(function(){
        // Only validate if this container actually has chips
        if ($(this).find('.product__chip').length > 0) {
          if ($(this).find('.product__chip.selected').length === 0) {
            allSelected = false; return false;
          }
        }
      });
    }
    else{
      $('.product__color-chips').each(function(){
        // Only validate if this container actually has chips
        if ($(this).find('.product__chip').length > 0) {
          if ($(this).find('.product__chip.selected').length === 0) {
            allSelected = false; return false;
          }
        }
      });
    }

    // Check if the currently selected variant combination is actually available
    var variantIsAvailable = true;
    if (allSelected) {
      // Get all product variants from the JSON data
      var variantsJsonEl = $('[data-variant-json]');
      if (variantsJsonEl.length) {
        try {
          var variants = JSON.parse(variantsJsonEl.text());

          // For bra products, check based on selected band + cup + color
          if(isComplexBra) {
            var selectedBand = $('.product__chip[data-type="band"].selected').data('value');
            var selectedCup = $('.product__chip[data-type="cup"].selected').data('value');
            var selectedColor = $('.product__chip[data-type="color"].selected').data('value') || $('#option1').val();
            var combinedSize = selectedBand + selectedCup;
            
            var hasColor = $('.product__variants-wrapper').data('has-color');

            // Find variant matching the selected band + cup (+ color if applicable)
            var matchingVariant = variants.find(function(variant) {
              if (hasColor) {
                // Variant option1 = color, option2 = size (band+cup combined)
                return variant.option1 === selectedColor && variant.option2 === combinedSize;
              } else {
                // No color, option1 = size (band+cup combined)
                return variant.option1 === combinedSize;
              }
            });

            if (matchingVariant) {
              variantIsAvailable = matchingVariant.available;
            } else {
              // No matching variant found means invalid combination
              variantIsAvailable = false;
            }
          } else {
            // For non-bra products, use the variant-selector value
            var variantSelector = $('#variant-selector');
            if (variantSelector.length) {
              var selectedVariantId = variantSelector.val();

              if (selectedVariantId) {
                var matchingVariant = variants.find(function(variant) {
                  return variant.id == selectedVariantId;
                });

                if (matchingVariant) {
                  variantIsAvailable = matchingVariant.available;
                } else {
                  variantIsAvailable = false;
                }
              }
            }
          }
        } catch(e) {
          console.error('Error parsing variant JSON:', e);
        }
      }
    }

    // Update button state and text
    var $submitButton = $('.product-form__cart-submit');
    var $buttonText = $submitButton.find('[data-add-to-cart-text]');



    if(allSelected && variantIsAvailable){
      // Enable button and show "Add to cart" text
      $submitButton.removeAttr('disabled').removeAttr('title');
      if($buttonText.length) {
        var langAvailable = $submitButton.data('lang-available') || 'Add to cart';
        $buttonText.text(langAvailable);
      }
    } else {
      // Disable button and update text
      var disabledMessage = allSelected && !variantIsAvailable ? 'This combination is not available' : 'Please select an option from every group';
      $submitButton.attr('disabled', 'disabled').attr('title', disabledMessage);

      if($buttonText.length) {
        if(allSelected && !variantIsAvailable) {
          // Show "Sold out" for unavailable combinations
          var langSoldOut = $submitButton.data('lang-sold-out') || 'Sold out';
          $buttonText.text(langSoldOut);
        } else {
          // Show "Unavailable" for incomplete selections
          var langUnavailable = $submitButton.data('lang-unavailable') || 'Unavailable';
          $buttonText.text(langUnavailable);
        }
      }
    }

    // Handle error messages for bra products
    if(isComplexBra){
      // Since we always have a default selection for bra products, hide all error messages
      $('[data-band-error]').hide();
      $('[data-cup-error]').hide();
      $('[no-size-error]').hide();
    } else {
      // For non-bra products, use the generic error
      if($('.product__chip.selected').length == 0){
        $('[no-size-error]').show();
      } else {
        $('[no-size-error]').hide();
      }

      // Hide bra-specific errors
      $('[data-band-error]').hide();
      $('[data-cup-error]').hide();
    }
}

jQuery(document).ready(function ($) {

  // Quick view: capture phase so (1) injected Searchtap rows work and (2) the event never
  // reaches duplicate listeners theme ProductItem added on first-paint buttons (avoids double-open).
  document.addEventListener(
    'click',
    function (e) {
      var link = e.target.closest && e.target.closest('.show-product-quickview');
      if (!link || !document.documentElement.contains(link)) return;
      e.preventDefault();
      e.stopPropagation();
      var url = link.getAttribute('href');
      if (url && typeof window.openQuickView === 'function') {
        window.openQuickView(url);
      }
    },
    true
  );

  $('.fs-product-card-title').matchHeight();
  if ($('.flair-badge').length > 0) {
    $('.flair-badge-layout').matchHeight();
    $('.fs-product-card-title').matchHeight();
  }

  function checkSelected() {
    if($('.product__details').length){
      // For bra products, don't restore from localStorage via clicks
      // The initialization code below (line 290) handles it properly
      // by preserving the color from the URL
      var productType = $('.product__meta #currproduct-type').val().toLowerCase().replace(' ', '_');

      if (!productType.includes('bra')) {
        // For non-bra products, restore from localStorage
        var selectedSwatch = localStorage.getItem(productType);
        if(selectedSwatch != '' && selectedSwatch != undefined && selectedSwatch != null){
          var selection = JSON.parse(selectedSwatch);
          $.each(selection, function(key, value) {
            var $chip = $('.product__chip[data-type="' + key + '"][data-value="' + value + '"]:not(.disabled)');
            if ($chip.length) { $chip.trigger('click'); }
          });
        }
      }
    }
  }

  // Wait for variant availability system to finish marking disabled options
  // Then check if the currently selected combination is valid
  setTimeout(function() {
    checkSelected();
  }, 100);

  // Run updateBraSizeAvailability independently with longer delay
  setTimeout(function() {
    updateBraSizeAvailability();
  }, 500);

  // Mark initial band/cup selection for bra products
  setTimeout(function() {

    if ($('#currproduct-type[value*="Bra"]').length) {
      // Check if there's a saved bra size preference from clicking external color swatch
      var savedPreference = localStorage.getItem('bra_size_preference');
      var preferredBand = null;
      var preferredCup = null;


      if (savedPreference) {
        try {
          var preference = JSON.parse(savedPreference);
          preferredBand = preference.band;
          preferredCup = preference.cup;
          // Clear the preference after reading it (one-time use)
          localStorage.removeItem('bra_size_preference');
        } catch(e) {
          console.error('Error parsing bra size preference:', e);
        }
      }

      // Get the currently selected variant from the form
      var selectedVariantId = $('#variant-selector').val();


      if (selectedVariantId) {
        // Get variant data
        var variantsJsonEl = $('[data-variant-json]');
        if (variantsJsonEl.length) {
          try {
            var variants = JSON.parse(variantsJsonEl.text());
            var selectedVariant = variants.find(function(v) { return v.id == selectedVariantId; });

            // If we have a preferred size from external color switch, try to use it
            if (preferredBand && preferredCup && selectedVariant) {
              var currentColor = selectedVariant.option1;
              var preferredSize = preferredBand + preferredCup;

              // Try to find variant with preferred size and current color
              var preferredVariant = variants.find(function(v) {
                return v.option1 === currentColor && v.option2 === preferredSize;
              });

              // Use preferred variant if it exists (available or not)
              if (preferredVariant) {
                selectedVariant = preferredVariant;
              }
            }

            // Don't auto-switch away from unavailable variants
            // Users should be able to see sold-out variants and the "Sold out" button
            // Removed auto-switching logic that was causing color changes

            if (selectedVariant && selectedVariant.option2) {

              // option2 is the combined size like "34D"
              var combinedSize = selectedVariant.option2;

              // Extract band and cup (e.g., "34D" -> band: "34", cup: "D")
              var bandMatch = combinedSize.match(/^(\d+)/);
              var cupMatch = combinedSize.match(/([A-Z]+)$/);

              if (bandMatch && cupMatch) {
                var band = bandMatch[1];
                var cup = cupMatch[1];

                // First remove selected class from ALL band and cup chips
                $('.product__chip[data-type="band"]').removeClass('selected');
                $('.product__chip[data-type="cup"]').removeClass('selected');

                // Then mark only the correct band and cup chips as selected
                $('.product__chip[data-type="band"][data-value="' + band + '"]').addClass('selected');
                $('.product__chip[data-type="cup"][data-value="' + cup + '"]').addClass('selected');

                // Update the labels
                $('[data-bandsize-value]').text(band);
                $('[data-cupsize-value]').text(cup);

                // Store in localStorage
                var productType = $('#currproduct-type').val().toLowerCase();
                var storageKey = productType.replace(' ', '_');
                var braOptions = {
                  band: band,
                  cup: cup
                };
                localStorage.setItem(storageKey, JSON.stringify(braOptions));

                // Find the variant ID for this combination
                var targetVariant = variants.find(function(v) {
                  return v.option1 === selectedVariant.option1 && v.option2 === combinedSize;
                });

                if (targetVariant) {


                  // CRITICAL FIX: Update option1 (color) FIRST to match the selected variant
                  var $option1Select = $('#option1');
                  if ($option1Select.length) {

                    $option1Select.val(selectedVariant.option1);
                    // Don't trigger change yet - wait until option2 is also set
                  }

                  // Then update option2 (band+cup size)
                  var $option2Select = $('[name="options[Size]"]');
                  if ($option2Select.length) {

                    $option2Select.val(combinedSize);
                    // Now trigger change on option2, which will recalculate the variant with the correct color
                    $option2Select.trigger('change');
                    if ($option2Select[0]) $option2Select[0].dispatchEvent(new Event('change', { bubbles: true }));
                  }

                  // Then click the combined size button to trigger visual updates
                  var $combinedButton = $('.chips2-wrap .product__chip[data-value="' + combinedSize + '"]');
                  if ($combinedButton.length) {
                    $combinedButton.trigger('click');
                  }
                }

                // Call manageError after marking selections to update button state
                manageError();
              }
            }
          } catch(e) {
            console.error('Error marking initial selection:', e);
          }
        }
      }
    }
  }, 550);

  // Run manageError after variant availability and chips have been initialized
  // (This is a fallback in case the bra product code doesn't run)
  setTimeout(function() {
    manageError();
  }, 650);

  // Listen for variant changes from the select elements (triggered by OptionButtons)
  $(document).on('change', '.dynamic-variant-input', function() {
    var changedSelect = $(this);
    var selectId = changedSelect.attr('id');

    // Check if this is option1 (color) changing and the product actually has a color option
    var hasColor = $('.product__variants-wrapper').data('has-color');
    if (selectId === 'option1' && hasColor) {
      var selectedColor = changedSelect.val();

      // Get all product variants from JSON
      var variantsJsonEl = $('[data-variant-json]');
      if (variantsJsonEl.length && selectedColor) {
        try {
          var variants = JSON.parse(variantsJsonEl.text());

          // Find all available variants for the selected color
          var availableVariantsForColor = variants.filter(function(variant) {
            return variant.option1 === selectedColor && variant.available;
          });

          // If there are available variants for this color, select the first one
          if (availableVariantsForColor.length > 0) {
            var firstAvailableVariant = availableVariantsForColor[0];

            // For bra products, handle band/cup selection
            if ($('#currproduct-type[value*="Bra"]').length) {
              // Deselect all band and cup chips first
              $('.product__chip[data-type="band"]').removeClass('selected');
              $('.product__chip[data-type="cup"]').removeClass('selected');

              // Extract band and cup from the first available variant
              var combinedSize = firstAvailableVariant.option2;
              var bandMatch = combinedSize.match(/^(\d+)/);
              var cupMatch = combinedSize.match(/([A-Z]+)$/);

              if (bandMatch && cupMatch) {
                var band = bandMatch[1];
                var cup = cupMatch[1];

                // Mark the band and cup chips as selected
                $('.product__chip[data-type="band"][data-value="' + band + '"]').addClass('selected');
                $('.product__chip[data-type="cup"][data-value="' + cup + '"]').addClass('selected');

                // Update labels
                $('[data-bandsize-value]').text(band);
                $('[data-cupsize-value]').text(cup);

                // Store in localStorage
                var productType = $('#currproduct-type').val().toLowerCase();
                var storageKey = productType.replace(' ', '_');
                var braOptions = {
                  band: band,
                  cup: cup
                };
                localStorage.setItem(storageKey, JSON.stringify(braOptions));

                // CRITICAL: Update the option2 select FIRST before clicking the button
                var $option2Select = $('[name="options[Size]"]');
                if ($option2Select.length) {
                  $option2Select.val(combinedSize);
                  // Trigger change event so theme.js recalculates the variant
                  $option2Select.trigger('change');
                  if ($option2Select[0]) $option2Select[0].dispatchEvent(new Event('change', { bubbles: true }));
                }

                // Then trigger click on the combined size button to update the variant visual state
                var $combinedButton = $('.chips2-wrap .product__chip[data-value="' + combinedSize + '"]');
                if ($combinedButton.length) {
                  $combinedButton.trigger('click');
                }
              }
            } else {
              // For regular products, select the first available size
              // Update the #variant-selector with the correct variant ID
              var $variantSelector = $('#variant-selector');
              if ($variantSelector.length) {
                $variantSelector.val(firstAvailableVariant.id);
              }

              var option2Select = $('[name="options[Size]"]');
              if (option2Select.length && firstAvailableVariant.option2) {
                // Update the select input
                option2Select.val(firstAvailableVariant.option2);
                option2Select.trigger('change');
                if (option2Select[0]) option2Select[0].dispatchEvent(new Event('change', { bubbles: true }));

                // Update the visual chip/button if it exists
                var $sizeChip = $('.product__chip[data-value="' + firstAvailableVariant.option2 + '"]');
                if ($sizeChip.length) {
                  $('.product__chip').removeClass('selected');
                  $sizeChip.addClass('selected');
                }
              }
            }
          } else {
            // No available variants for this color
            if ($('#currproduct-type[value*="Bra"]').length) {
              // Deselect band and cup
              $('.product__chip[data-type="band"]').removeClass('selected');
              $('.product__chip[data-type="cup"]').removeClass('selected');

              // Clear labels
              $('[data-bandsize-value]').text('');
              $('[data-cupsize-value]').text('');

              // Clear localStorage
              var productType = $('#currproduct-type').val().toLowerCase().replace(' ', '_');
              var storageKey = productType.replace(' ', '_');
              localStorage.removeItem(storageKey);

              // Show error messages
              $('[data-band-error]').show();
              $('[data-cup-error]').show();
            }
          }
        } catch(e) {
          console.error('Error in color change handler:', e);
        }
      }
    }

    // Give variant availability system time to update disabled states
    setTimeout(function() {
      updateBraSizeAvailability(); // Update band/cup availability after color change
      manageError();
    }, 200);
  });
});

$(document).on('click', '.product__chip', function(e){
  var optionType = $(this).data('type');
  var optionValue = $(this).data('value');
  var productType = $('#currproduct-type').val().toLowerCase();
  var storageKey = productType.replace(' ', '_');

  // Check if this is a complex bra (has band/cup chips)
  var isComplexBra = productType.includes('bra') && $('.product__chip[data-type="band"]').length > 0;

  // For complex bra products, don't check generic "any chip selected" logic
  // We need BOTH band and cup selected, which is checked in manageError()
  if(!isComplexBra) {
    if($('.product__chip.selected').length == 0){
      $('[no-size-error]').show();
    }else{
      $('[no-size-error]').hide();
    }
  }

  if(isComplexBra) {
    // For bra products, manage band and cup selection separately
    if(optionType === 'band' || optionType === 'cup') {
      // Remove selected class from all chips of this type
      $('.product__chip[data-type="' + optionType + '"]').removeClass('selected');
      // Add selected class to the clicked chip
      $(this).addClass('selected');

      // Update availability of the other option type based on the selected one
      // This will gray out incompatible options
      updateBraSizeAvailability();
    }

    var braOptions = localStorage.getItem(storageKey);
    braOptions = braOptions ? JSON.parse(braOptions) : {};
    if(optionType === 'band') {
      braOptions['band'] = optionValue;
      $('[data-bandsize-value]').text(optionValue);
    } else if(optionType === 'cup') {
      braOptions['cup'] = optionValue;
      $('[data-cupsize-value]').text(optionValue);
    }
    localStorage.setItem(storageKey, JSON.stringify(braOptions));

    // If both band and cup are selected, update the form
    if(braOptions.band && braOptions.cup) {
      var combinedSize = braOptions.band + braOptions.cup;

      // CRITICAL: Update the option2 select directly without triggering the combined button
      // (to avoid infinite loop)
      var $option2Select = $('[name="options[Size]"]');
      if ($option2Select.length) {
        $option2Select.val(combinedSize);
        // Trigger change event so theme.js recalculates the variant
        $option2Select.trigger('change');
        if ($option2Select[0]) $option2Select[0].dispatchEvent(new Event('change', { bubbles: true }));
      }

      // Call manageError after a delay to ensure variant is updated
      setTimeout(function() {
        manageError();
      }, 100);
    } else {
      // Only one option selected, call manageError immediately
      manageError();
    }
  } else {
    // For Simple Bras (S/M/L) or non-bra products
    // Manually handle the visual selection state

    // Remove selected class from other chips in the same group
    $(this).siblings('.product__chip').removeClass('selected');

    // Add selected class to this chip
    $(this).addClass('selected');

    // CRITICAL: Update the hidden select input so theme.js knows the option changed
    // The select is usually a sibling or in the same container
    var $parent = $(this).closest('.product__color-chips, .select-wrapper');
    var $select = $parent.find('select');

    if($select.length && $select.val() !== optionValue) {
      $select.val(optionValue);
      $select.trigger('change');
      if ($select[0]) $select[0].dispatchEvent(new Event('change', { bubbles: true }));
    }

    var options = {};
    options[optionType] = optionValue;
    localStorage.setItem(storageKey, JSON.stringify(options));
    manageError();
  }


});

jQuery(document).ready(function($) {
  enableSwatchSlide();
  $(document).on('click', '.product-swatches-options__item', function(e) {
    e.preventDefault();
    const $swatch = $(this);
    $swatch.siblings().removeClass('active-swatch-item');
    $swatch.addClass('active-swatch-item');
    const variantId = +$swatch.data('variation-id');
    const $productItem = $swatch.closest('.product-item');
    const productUrl = $swatch.data('swatch-url');

    if (!productUrl) return;

    $.getJSON(productUrl + '.js', function(product) {
      const variant = product.variants.find(v => v.id === variantId);
      if (variant) {
        var nextImgPosition = 0;
        if (variant.featured_image) {
          var newImgSrc = variant.featured_image.src;
          nextImgPosition = variant.featured_image.position + 1;
          $productItem.find('.product-item__image.product-item__image--one').html(`<img src="${newImgSrc}" class="image_img">`);
        }
        var productImages = product.media;
        productImages.forEach(function(item) {
          if(item.position == nextImgPosition){
            $productItem.find('.product-item__image.product-item__image--two').html(`<img src="${item.src}" class="image_img">`);
          }
        });
        $productItem.find('.product-item__image--two').removeClass('active');
        var formattedPrice = (typeof Shopify !== 'undefined' && Shopify.formatMoney)
          ? Shopify.formatMoney(variant.price, Shopify.money_format)
          : '$' + (variant.price / 100).toFixed(2);
        $productItem.find('.product-item__price > .sale').text(formattedPrice);
        var newProductLink = productUrl + '?variant=' + variant.id;
        $productItem.find('a').attr('href', newProductLink);
      }
      else{
        var nextImgPosition = 0;
        if (product.featured_image) {
          var newImgSrc = product.featured_image;
          nextImgPosition = 2;
          $productItem.find('.product-item__image.product-item__image--one').html(`<img src="${newImgSrc}" class="image_img">`);
        }
        productImages.forEach(function(item) {
          if(item.position == nextImgPosition){
            $productItem.find('.product-item__image.product-item__image--two').html(`<img src="${item.src}" class="image_img">`);
          }
        });
        $productItem.find('.product-item__image--two').removeClass('active');
        var formattedPrice = (typeof Shopify !== 'undefined' && Shopify.formatMoney)
          ? Shopify.formatMoney(product.price, Shopify.money_format)
          : '$' + (product.price / 100).toFixed(2);
        $productItem.find('.product-item__price > .sale').text(formattedPrice);
        var newProductLink = productUrl;
        $productItem.find('a').attr('href', newProductLink);
      }
    });
  });

  var popupTimeout;
  var currentSwatch = null;
  var currentPopup = null;

  function updatePopupPosition() {
    if (currentSwatch && currentPopup && currentPopup.is(':visible')) {
      var rect = currentSwatch[0].getBoundingClientRect();
      currentPopup.css({
        left: rect.left,
        top: rect.top - 10
      });
    }
  }

  $('.product__color-swatch').on('mouseenter', function () {
    clearTimeout(popupTimeout);

    var $swatch = $(this);
    var optionHandle = $swatch.attr('data-option-handle');

    $('.color-swatchnum-popup').stop(true, true).fadeOut();

    var $popup = $('.color-swatchnum-popup').filter(function () {
      var colorName = $(this).attr('data-color-name');
      return optionHandle && colorName && optionHandle.indexOf(colorName) !== -1;
    }).first();

    if ($popup.length) {
      var rect = $swatch[0].getBoundingClientRect();

      $popup.find('.color-swatchnum-color-preview').css('background', $swatch.css('background'));

      $popup.css({
        position: 'fixed',
        left: rect.left,
        top: rect.top - 10
      }).stop(true, true).fadeIn();

      currentSwatch = $swatch;
      currentPopup = $popup;
    }
  });

  $('.product__color-swatch, .color-swatchnum-popup').on('mouseleave', function () {
    popupTimeout = setTimeout(function () {
      $('.color-swatchnum-popup').fadeOut();
      currentSwatch = null;
      currentPopup = null;
    }, 150);
  });

  $('.color-swatchnum-popup').on('mouseenter', function () {
    clearTimeout(popupTimeout);
  });

  $(window).on('scroll', function () {
    updatePopupPosition();
  });

  // Save band+cup selection when clicking external color swatches (different products)
  $(document).on('click', 'a.product-color__link.product__color-swatch[href]', function() {
    // Only for bra products
    if ($('#currproduct-type[value*="Bra"]').length) {
      var selectedBand = $('.product__chip[data-type="band"].selected').data('value');
      var selectedCup = $('.product__chip[data-type="cup"].selected').data('value');

      if (selectedBand && selectedCup) {
        // Save with a global key that persists across different products
        localStorage.setItem('bra_size_preference', JSON.stringify({
          band: selectedBand,
          cup: selectedCup
        }));
      }
    }
  });

});

function enableSwatchSlide() {
  if (typeof Swiper === 'undefined') return;
  document.querySelectorAll('.product-swatches__wrap.swiper').forEach(function (el) {
    if (el.swiper) return;
    var pag = el.querySelector('.swiper-pagination');
    var next = el.querySelector('.swiper-button-next');
    var prev = el.querySelector('.swiper-button-prev');
    var opts = {
      slidesPerView: 'auto',
      grabCursor: true,
      mousewheel: true,
      freeMode: true,
      spaceBetween: 8,
      observer: true,
      observeParents: true,
    };
    if (pag) opts.pagination = { el: pag };
    if (next && prev) {
      opts.navigation = { nextEl: next, prevEl: prev };
    }
    try {
      new Swiper(el, opts);
    } catch (e) {}
  });
}

document.addEventListener("DOMContentLoaded", function () {
  const triggerContainer = document.querySelector('.collection__infinite-trigger');

  if (!triggerContainer) return;

  const link = triggerContainer.querySelector('a');
  if (!link) return;

  let clicked = false;

  window.addEventListener('scroll', function () {
    const scrollTop = window.scrollY;
    const docHeight = document.documentElement.scrollHeight;
    const winHeight = window.innerHeight;

    const scrollPercent = (scrollTop + winHeight) / docHeight;

    if (scrollPercent > 0.75) {
      link.click();
    }
  });
});


(function () {
  function mutationsIncludeProductNodes(mutations) {
    for (var i = 0; i < mutations.length; i++) {
      var nodes = mutations[i].addedNodes;
      if (!nodes || !nodes.length) continue;
      for (var j = 0; j < nodes.length; j++) {
        var n = nodes[j];
        if (n.nodeType !== 1) continue;
        if (n.classList && n.classList.contains('product-item')) return true;
        if (n.querySelector && n.querySelector('.product-item')) return true;
      }
    }
    return false;
  }

  function searchtapAfterProductsInjected() {
    if (typeof FlairApp !== 'undefined' && typeof FlairApp.refreshProductBadges === 'function') {
      try {
        FlairApp.refreshProductBadges();
      } catch (e) {}
    }
    requestAnimationFrame(function () {
      if (typeof enableSwatchSlide === 'function') enableSwatchSlide();
      if (window.yotpoWidgetsContainer && typeof window.yotpoWidgetsContainer.initWidgets === 'function') {
        try {
          window.yotpoWidgetsContainer.initWidgets();
        } catch (e) {}
      }
      if (typeof jQuery !== 'undefined' && typeof jQuery.fn.matchHeight === 'function') {
        jQuery('.fs-product-card-title').matchHeight();
        if (jQuery('.flair-badge').length > 0) {
          jQuery('.flair-badge-layout').matchHeight();
          jQuery('.fs-product-card-title').matchHeight();
        }
      }
    });
  }

  function debounce(fn, ms) {
    var t;
    return function () {
      clearTimeout(t);
      var ctx = this;
      var args = arguments;
      t = setTimeout(function () {
        fn.apply(ctx, args);
      }, ms);
    };
  }

  var debouncedRefresh = debounce(searchtapAfterProductsInjected, 250);
  window.searchtapRefreshProductBadges = searchtapAfterProductsInjected;

  function attachSearchtapFlairObserver() {
    var mount = document.querySelector('#collectionmodalcontainer') || document.querySelector('searchtap') || document.querySelector('.st-collection-content');
    if (!mount || mount.getAttribute('data-flair-mo') === '1') return;
    mount.setAttribute('data-flair-mo', '1');
    var obs = new MutationObserver(function (mutations) {
      if (mutationsIncludeProductNodes(mutations)) debouncedRefresh();
    });
    obs.observe(mount, { childList: true, subtree: true });

    // Fallback event listeners
    window.addEventListener('st.collection.paginated', debouncedRefresh);
    window.addEventListener('st:collection:updated', debouncedRefresh);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', attachSearchtapFlairObserver);
  } else {
    attachSearchtapFlairObserver();
  }

  // Global-e Price Patch for SearchTap and other dynamic grids
  (function() {
    function patchPrices() {
      if (!window.theme) return;
      const currencyCode = window.theme.currencyCode;
      const currencySymbol = window.theme.currencySymbol;
      if (!currencyCode) return;

      const priceSelectors = [
        '.product-item__price s:not([data-ge-patched])',
        '.customAddedPrice s:not([data-ge-patched])',
        '.product-item__price:not([data-ge-patched])',
        '.sale:not([data-ge-patched])',
        '.price-item:not([data-ge-patched])',
        '.product-block-header__price:not([data-ge-patched])',
        '.customAddedPrice .sale:not([data-ge-patched])',
        '.st-product-price:not([data-ge-patched])',
        '.st-product-price span:not([data-ge-patched])',
        '.st-product-price s:not([data-ge-patched])',
        '.st-price:not([data-ge-patched])',
        '.st-price span:not([data-ge-patched])',
        '.st-price s:not([data-ge-patched])',
        '[class*="price"]:not([data-ge-patched])',
        '[class*="Price"]:not([data-ge-patched])'
      ];

      const priceElements = document.querySelectorAll(priceSelectors.join(','));
      
      priceElements.forEach(el => {
        // Skip if it's already being handled by Liquid (has USD)
        if (el.textContent.includes(currencyCode)) {
          el.setAttribute('data-ge-patched', 'true');
          return;
        }

        if (el.textContent.includes('$')) {
          let hasChanged = false;
          const walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, null, false);
          let node;
          while(node = walker.nextNode()) {
            const val = node.nodeValue;
            if (val.includes('$') || (currencySymbol !== '$' && val.includes(currencySymbol))) {
               // Add 'money' class to help Global-e find and convert the price
               if (!el.classList.contains('money')) {
                 el.classList.add('money');
               }

               // Regex to find either the current currency symbol or '$' followed by optional spaces and numbers
               // This helps catch unconverted SearchTap prices ($) even when we are in a different currency
               const pattern = (currencySymbol === '$') ? '\\$' : `(\\$|${currencySymbol.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&')})`;
               const symbolRegex = new RegExp(pattern + '\\s*([0-9]+([.,][0-9]{1,2})?)', 'g');
               
               const newVal = val.replace(symbolRegex, function(match) {
                 if (match.includes(currencyCode)) return match;
                 // If we found a $ but the local symbol is different, we replace it to match the store's current state
                 // Note: This doesn't fix the exchange rate, but makes the symbol consistent.
                 let formattedMatch = match.replace(/\s+/g, '');
                 if (currencySymbol !== '$' && formattedMatch.startsWith('$')) {
                   formattedMatch = formattedMatch.replace('$', currencySymbol);
                 }
                 return formattedMatch + ' ' + currencyCode;
               });
               if (newVal !== val) {
                 node.nodeValue = newVal;
                 hasChanged = true;
               }
            }
          }
          if (hasChanged) {
            el.setAttribute('data-ge-patched', 'true');
          }
        }
      });
    }

    const observer = new MutationObserver((mutations) => {
      patchPrices();
    });

    function initGEPatch() {
      patchPrices();
      // Observe document.body to catch overlays and search results in different containers
      observer.observe(document.body, { childList: true, subtree: true });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initGEPatch);
    } else {
      initGEPatch();
    }
    
    // Also hook into custom events if SearchTap/Theme uses them
    window.addEventListener('st.collection.paginated', patchPrices);
    window.addEventListener('quick-cart:updated', patchPrices);
    window.addEventListener('cart:updated', patchPrices);

    // Add CSS for price separation
    // :not(:empty) prevents the dash from rendering when <s> compare-at is present
    // but blank — happens when the product isn't on sale, or when Global-E patches
    // the price and clears the strikethrough content.
    const style = document.createElement('style');
    style.textContent = `
      .cart__form-item-price-wrapper s:not(:empty) + .sale-price::before,
      .cart__form-item-price-wrapper s:not(:empty) + .cart__form-item-price:not(s)::before {
        content: ' - ';
      }
    `;
    document.head.appendChild(style);
  })();

  // Orbe + Global-e Integration: Connect theme country selector to Orbe redirection
  (function() {
    function initOrbeConnector() {
      // Use event delegation to handle clicks on country options
      document.body.addEventListener('click', function(e) {
        const option = e.target.closest('[data-disclosure="currency"] [data-disclosure-option]');
        if (option) {
          const countryCode = option.getAttribute('data-value');
          if (countryCode) {
            // Official Orbe integration: Update the URL with the country parameter
            const url = new URL(window.location.href);
            url.searchParams.set('country', countryCode);
            window.location.href = url.toString();
          }
        }
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initOrbeConnector);
    } else {
      initOrbeConnector();
    }
  })();
})();